import { Group, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import SkillsterIcon from "../SkillsterIcon/SkillsterIcon";
import { AnimatePresence, motion } from "framer-motion";

function LogoTeacher({
  fontSize,
  iconSize,
  color,
  hideText,
}: {
  fontSize?: number;
  iconSize?: number;
  color?: string;
  hideText?: boolean;
}) {
  const { t } = useTranslation();
  const size = fontSize ?? 32;

  return (
    <AnimatePresence>
      <Group gap={size < 24 ? 15 : 18} wrap="nowrap">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0 }}
        >
          <SkillsterIcon
            size={iconSize ?? 50}
            backgroundColor="#354871"
            borderColor="var(--mantine-color-blue-2)"
          />
        </motion.div>
        {!hideText && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0 }}
            transition={{ delay: 0.1 }}
          >
            <Title size={fontSize ?? 32} c={color ?? "bluegray.7"}>
              {t("login.title")}
            </Title>
          </motion.div>
        )}
      </Group>
    </AnimatePresence>
  );
}

export default LogoTeacher;
